export default __webpack_public_path__ + "static/media/1772.baa129e2.JPG";